export default {
  getList: {
    method: 'post',
    url: '/admincp/node/type/list?archive=ARCHIVE'
  },
  add: {
    method: 'post',
    url: '/admincp/node/type'
  },
  getDetail: {
    method: 'get',
    url: '/admincp/node/type/ID'
  },
  edit: {
    method: 'put',
    url: '/admincp/node/type/ID'
  },
  delete: {
    method: 'delete',
    url: '/admincp/node/type'
  },
  archive: {
    method: 'delete',
    url: '/admincp/node/type/archive'
  },
  restore: {
    method: 'put',
    url: '/admincp/node/type/restore'
  },
  finds: {
    method: 'get',
    url: '/admincp/node/type/find?key=KEY'
  }
}
